import { render, staticRenderFns } from "./queryconsumerwarning.vue?vue&type=template&id=1115e830&scoped=true"
import script from "./queryconsumerwarning.vue?vue&type=script&lang=js"
export * from "./queryconsumerwarning.vue?vue&type=script&lang=js"
import style0 from "./queryconsumerwarning.vue?vue&type=style&index=0&id=1115e830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115e830",
  null
  
)

export default component.exports